import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ffr72e9f6: FaireProductEntity = {
  token: "p_3ffr72e9f6",
  type: "product",
  name: "Body Crème - Incendier",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/8192ba2ef46d97e41230a9b93faf93927cad30e40bbe2ed29789e918a5842de9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c43dd9d41fb7f07f30a0541eef54680fb3d7c68cd7f22290c4d93f3159cb1a61.jpeg",
    "https://cdn.faire.com/fastly/a17992da9b491964d0d7cb82d7a1bd1eb2e4f573b7c6dc98806513b7194acfa7.jpeg",
    "https://cdn.faire.com/fastly/cab9a5b904991b7a05962616dc287a7337317c16b5166a97a0a6299d217b9409.jpeg",
    "https://cdn.faire.com/fastly/94d1ea4382ebad0cf67f36f2877dec7360a28cd2e346e47e85c450ad43a588da.jpeg",
    "https://cdn.faire.com/fastly/61e4df65cd73718057d522e65ede9f4ac9938fbaf3de97ff2beb563a1a9dfa85.jpeg",
  ],
  priceDollars: 20.65,
  description:
    "A decadent crème that delivers lasting softness while smoothing and refining the skin. Botanical oils and butters blend with Peptides, Niacinamide, Ceramides, and Multi-Weight Hyaluronic Acid to nourish and restore, while mood-shifting adaptogens and two signature scents heighten connection through the senses.\n",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:42.329Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
